import React from 'react'
import { nanoid } from 'nanoid'
import { AnimatePresence, motion } from 'framer-motion'

import { type ScheduleAccordionKey } from './hooks/useScheduleVM'
import useMediaQuery from '../../../hooks/useMediaQuery'

interface AccordionProps {
    group: string
    expanded: ScheduleAccordionKey
    setExpanded: (value: ScheduleAccordionKey) => void
    countLable: number
    imgCover: string
    children: React.ReactNode
}

export function ScheduleAccordion({
    group,
    expanded,
    setExpanded,
    countLable,
    imgCover,
    children
}: AccordionProps): JSX.Element {
    const isOpen = group === expanded
    const basic = ['Advertises', 'Offers', 'Viewings']
    const isDesktop = useMediaQuery('(min-width: 992px)')


    return (
        <>
            <motion.header
                initial={false}
                onClick={() => setExpanded(isOpen ? false : group)}
                // eslint-disable-next-line react/no-children-prop
                children={
                    <div key={nanoid()} className={'position-relative   cursor-pointer '}>
                        <img
                            className={`w-100 ${isDesktop ? 'h-125px' : "h-100px"}  object-fit-cover mb-2 rounded opacity-100`}
                            src={imgCover}
                            alt={`${group}_group_liable`}
                        />
                        <span className="d-block fs-2  min-w-30px max-w-30px text-center position-absolute rounded-0 rounded-bottom rounded-end-0  translate-middle badge badge-secondary opacity-75"
                            style={{ top: '12px', right: '-15px' }}
                        >
                            {countLable}
                        </span>
                        <span className="ps-4 fs-4x  fs-lg-3x  fw-semi-bold text-white position-absolute lh-1 ls-n2  " style={{ top: '9px', left: '0px', textShadow: '1px 1px 10px #332d2dd9' }}>
                            {group}
                            {basic.includes(group) && <div className="ps-8 ms-8 fs-lg-1x">Attentions</div>}

                        </span>
                    </div>
                }
            />
            <AnimatePresence initial={false}>
                {isOpen && (
                    <motion.section
                        key="content"
                        initial="collapsed"
                        animate="open"
                        exit="collapsed"
                        variants={{
                            open: { opacity: 1, height: 'auto' },
                            collapsed: { opacity: 0, height: 0 }
                        }}
                        transition={{ duration: 0.8, ease: [0.04, 0.62, 0.23, 0.98] }}
                    >
                        {children}
                    </motion.section>
                )}
            </AnimatePresence>
        </>
    )
}
